import Container from './view/container';
import Reducer from './reducer';

export const reducer = Reducer;
export default Container;
